import {
    CENTER_REGION_ID,
    DEFAULT_EDGE_WRAP_ORDER,
    LAYOUT_REGIONS,
    createEmptyRegions,
    normalizeDockZone,
} from './constants.js';
import { ensureLayoutStateRegions, resolveHostLayoutRegion } from './layoutRegions.js';

function normalizeRootEdgeOrder(order) {
    if (!Array.isArray(order)) return [...DEFAULT_EDGE_WRAP_ORDER];
    const deduped = [];
    for (const raw of order) {
        const zone = normalizeDockZone(raw);
        if (zone === 'center') continue;
        if (!deduped.includes(zone)) deduped.push(zone);
    }
    return deduped.length ? deduped : [...DEFAULT_EDGE_WRAP_ORDER];
}

export function getPanelZoneMap(layoutState, panelRegistry) {
    const zones = {};
    for (const [id, reg] of Object.entries(panelRegistry || {})) {
        if (reg?.isContentHost) continue;
        const z = reg?.defaultZone;
        if (z != null && z !== '') zones[id] = normalizeDockZone(z);
    }
    for (const [id, meta] of Object.entries(layoutState?.panels || {})) {
        if (meta?.layoutRegion) zones[id] = normalizeDockZone(meta.layoutRegion);
    }
    return zones;
}

export function createDockModel(layoutState, panelRegistry) {
    const state = layoutState || {};
    const regions = ensureLayoutStateRegions(state, getPanelZoneMap(state, panelRegistry));
    return {
        rootTree: state.root || null,
        rootEdgeOrder: normalizeRootEdgeOrder(state.edgeWrapOrder),
        regions: regions || createEmptyRegions(),
        panelMeta: state.panels || {},
    };
}

export function resolveRootRegionFromHit(hit, context = {}) {
    if (!hit) return 'center';
    if (hit.tier === 'root') {
        return normalizeDockZone(hit.region || hit.zone || 'center');
    }
    if (hit.hostType === 'center' || hit.nodeId === CENTER_REGION_ID) {
        return 'center';
    }

    const { root, regions, panelZoneMap } = context;
    const targetPanelId = hit.targetPanelId || hit.panelId || null;
    if (targetPanelId && panelZoneMap?.[targetPanelId]) {
        return normalizeDockZone(panelZoneMap[targetPanelId]);
    }

    if (root && regions) {
        const hostRegion = resolveHostLayoutRegion(root, regions, hit);
        if (hostRegion) return normalizeDockZone(hostRegion);
    }

    return 'center';
}

export function createDockConstraintContext(layoutState, panelRegistry) {
    const panelZoneMap = getPanelZoneMap(layoutState, panelRegistry);
    return {
        root: layoutState?.root || null,
        regions: ensureLayoutStateRegions(layoutState || {}, panelZoneMap),
        panelZoneMap,
    };
}

export function allowedRootZonesList(allowed = null, disallowed = null) {
    const all = [...LAYOUT_REGIONS];
    if (Array.isArray(allowed) && allowed.length) {
        return all.filter((r) => allowed.includes(r));
    }
    if (Array.isArray(disallowed) && disallowed.length) {
        return all.filter((r) => !disallowed.includes(r));
    }
    return all;
}

